import React, { useContext, VFC } from 'react';
import PlanTermContext from './context';
import T from 'i18n-react';
import Typography from '@material-ui/core/Typography';

const Money: VFC = () => {
  const { planTerm } = useContext(PlanTermContext);

  const { totalWages } = planTerm;

  return (
    <>
      <Typography component="span" variant="inherit">
        {T.translate('planPage.planTerms.totalAmount')}
      </Typography>
      &nbsp;
      <Typography component="span" variant="inherit" className="text-break-all">
        {totalWages > 0
          ? `${totalWages.toLocaleString()} ${T.translate('yen')}`
          : '-'}
      </Typography>
      &nbsp;
    </>
  );
};

export default Money;
